import Abstract from "../../../abstract-view/abstract.js";

export default class HeadingWrapper extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._headingContentElement = null;
  }

  getHeadingContentElement() {
    if (!this._headingContentElement) {
      this._headingContentElement = this._element.querySelector(`.heading_category-span`);
    }

    return this._headingContentElement;
  }

  getHeadingContent() {
    const headingContentElement = this.getHeadingContentElement();

    if (!headingContentElement) {
      return;
    }

    return headingContentElement.textContent.trim();
  }

  setHeadingContent(text) {
    const headingContentElement = this.getHeadingContentElement();

    if (!headingContentElement) {
      return;
    }

    headingContentElement.textContent = text;
  }
}
